// generated by the plop

import { BackupStatus } from '../../symbols';

export interface BackupsStateModel {
  status: BackupStatus;
}

export const BACKUPS_STATE_DEFAULT: BackupsStateModel = {
  status: null
};
